"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";

/**
 * Universal router hook that works in both App Router and Pages Router.
 * Uses next/navigation APIs which are compatible with both router types.
 */
const useUniversalRouter = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const getQueryParam = (key: string) => searchParams?.get(key) || "";

  const query = new Proxy(
    {},
    {
      get: (_, prop: string) => searchParams?.get(prop) || "",
    },
  ) as Record<string, string>;

  const searchString = searchParams?.toString() || "";
  const asPath = searchString ? `${pathname}?${searchString}` : pathname || "/";

  return {
    pathname: pathname || "/",
    asPath,
    query,
    searchParams,
    getQueryParam,
    push: router.push,
    replace: router.replace,
    back: router.back,
  };
};

export default useUniversalRouter;
